import { render } from "./SupportView.vue?vue&type=template&id=12e55f11&scoped=true&ts=true"
import script from "./SupportView.vue?vue&type=script&lang=ts"
export * from "./SupportView.vue?vue&type=script&lang=ts"

import "./SupportView.vue?vue&type=style&index=0&id=12e55f11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e55f11"]])

export default __exports__